import { Locale } from '@core/constants/locales.constants';
import { getPathname } from '@navigation';
import { Route } from '@core/types/routes.types';
import templateConfig from '@templateConfig';

export function generateFullPathname({
  locale,
  route,
  params = {},
  isStaticPageRevalidation = false,
  query,
}: {
  locale: Locale;
  route: Route;
  params?: { [key: string]: unknown };
  isStaticPageRevalidation?: boolean;
  query?: { [key: string]: unknown };
}): string {
  const url = getPathname({
    // @ts-expect-error - template is in fact a prop
    href: { pathname: route, template: route, params, query },
    locale: isStaticPageRevalidation
      ? templateConfig?.localization?.fileSystemLocale
      : locale,
  });

  if (url.includes('undefined')) {
    console.error(
      `generateFullPathname.utils.ts : Something went wrong while generating the url. The url contains an 'undefined' value : ${url} for route '${route}' and locale '${locale}'.`
    );
  }

  return url;
}
